import React from 'react';
import PropTypes from 'prop-types';
import { withRouter, Outlet } from 'react-router-dom';

import {
  GridLegacy as Grid,
  Button,
  TextField,
  Link,
  Typography
} from '@mui/material';
import useClasses from '../../helpers/useClasses';


import { Topbar } from './components';
import Maintenance from '../../components/UI/Maintenance'


const styles = theme => ({
  root: {
    paddingTop: 64,
    backgroundColor: theme.palette.background.default,
    height: '100%'
  },
  content: {
    height: '100%'
  },
  grid: {
    height: '100%'
  },
  quoteContainer: {
    [theme.breakpoints.down('md')]: {
      display: 'none'
    }
  },
  quote: {
    backgroundColor: theme.palette.neutral,
    height: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundImage: 'url(/images/edited-aerial-view-of-high-rise-building-2224933.jpg)',
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center'
  },
  quoteInner: {
    textAlign: 'center',
    flexBasis: '600px'
  },
  quoteText: {
    color: '#fff',
    fontWeight: 300
  },
  name: {
    marginTop: theme.spacing(3),
    color: '#fff'
  },
  bio: {
    color: '#fff'
  },
  contentContainer: {},
  content: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column'
  },
  contentHeader: {
    display: 'flex',
    alignItems: 'center',
    paddingTop: theme.spacing(5),
    paddingBototm: theme.spacing(2),
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2)
  },
  logoImage: {
    marginLeft: theme.spacing(4)
  },
  contentBody: {
    flexGrow: 1,
    display: 'flex',
    alignItems: 'center',
    [theme.breakpoints.down('md')]: {
      justifyContent: 'center'
    }
  },
});

const Auth = props => {
  // const { children } = props;

  const classes = useClasses(styles);

  return (
    <div className={classes.root}>
      <Maintenance /> 
      <Topbar />
      <main className={classes.content}>
        <Grid
          className={classes.grid}
          container
        >
          <Grid
            className={classes.quoteContainer}
            item
            lg={5}
          >
            <div className={classes.quote}>
              <div className={classes.quoteInner}>
                <Typography
                  className={classes.quoteText}
                  variant="h1"
                >
                  
                </Typography>
                <div className={classes.person}>
                  <Typography
                    className={classes.name}
                    variant="body1"
                  >
                    
                  </Typography>
                  <Typography
                    className={classes.bio}
                    variant="body2"
                  >
                    
                  </Typography>
                </div>
              </div>
            </div>
          </Grid>
          <Grid
            className={classes.content}
            item
            lg={7}
            xs={12}
          >
            <div className={classes.content}>
              <div className={classes.contentBody}>
                <Outlet />
              </div>
            </div>
          </Grid>
        </Grid>
      </main>
    </div>
  );
};

Auth.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string
};

export default Auth;
